import React from 'react';
import {IconButton, CircularProgress, useTheme, useMediaQuery} from '@material-ui/core';
import { PauseCircleFilled, PlayCircleFilled, Pause, PlayArrow } from '@material-ui/icons';

const PlayPauseButton = ({ player, status, expanded, main, size }) => {
  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.down('xs'));
  const togglePlayPause = (e) => {
    if (status === 'playing') {
      player.pause();
    } else if (status === 'paused') {
      player.play();
    }
    e.stopPropagation();
  };
  let style = {};
  if (!expanded && !main && !size) {
    style = {
      fontSize: '4em',
      color: theme.palette.pink,
    };
  } else if (size) {
    if (main) {
      style = {
        fontSize: size,
        padding: matchesXS ? 5 : 10,
        marginTop: matchesXS ? -4 : -3,
        marginLeft: matchesXS ? -3 : -3,
        // color: theme.palette.pink,
        fill: '#fff',
        background: '#ff0066',
        borderRadius: '50%'
      };
    } else {
      style = {
        fontSize: size,
        marginTop: -5,
        marginLeft: -5,
        color: theme.palette.pink,
      };
    }
  } else {
    style = {
      fontSize: '2.3em',
      color: '#fff',
    };
  }

  const showPlayPause = () => {
    if (status === 'playing') {
      if (size && main) {
        return <Pause style={style} />;
      } else {
        return <PauseCircleFilled style={style} />;
      }
    } else if (status === 'paused' || status === 'loaded') {
      if (size && main) {
        return <PlayArrow style={style}/>;
      } else {
        return <PlayCircleFilled style={style}/>;
      }
    } else if (status === 'loading') {
      return <CircularProgress />;
    }
  };

  return (
    <IconButton
      size="small"
      color="primary"
      onClick={togglePlayPause}
      disableFocusRipple={true}
      disableRipple={true}
    >
      {showPlayPause()}
    </IconButton>
  );
};

export default PlayPauseButton;
